import component from './CombiInitialSituation.vue';
import { StepCategoryId, StepId } from '~/consts/assistant-steps';
import {
  FormMultipleChoiceComponentConfig,
  FormMultipleChoiceValueType,
  StepDefinition,
} from '@/interfaces/step-definition';
import { AssistantStepContext } from '@/interfaces/context';
import { FormFieldType } from '@/consts/input-types';
import { FormFieldGroupId } from '~/consts/assistant-form-field-groups';

export interface CombiInitialSituationStepContext extends AssistantStepContext {
  housingSituation: FormMultipleChoiceValueType;
}

const config: StepDefinition = {
  component,
  hideSkipMessage: () => true,
  fields: [
    {
      component: {
        options: [
          {
            value: 'no',
          },
          {
            value: 'partially',
          },
          {
            value: 'yes',
          },
        ],
        columns: 1,
        singleAnswer: true,
      } as FormMultipleChoiceComponentConfig,
      name: 'initialSituation',
      required: true,
      type: FormFieldType.MultipleChoice,
      groupId: FormFieldGroupId.OBJECT,
    },
  ],
  id: StepId.COMBI_INITIAL_SITUATION,
  categoryId: StepCategoryId.COMBI,
};

export default config;
